<template>
  <div class="text-right">
    <button
      v-for="info in fileInfos"
      :key="info.fullUrl"
      v-show="showDownloadButton(info.pages)"
      type="button"
      class="btn btn-default btn-download"
      aria-hidden="true"
      @click="downloadGuide(info.fullUrl)"
    >
      <span class="fas fa-download mr-1"></span>
      <span>{{ info.fileName }}</span>
    </button>
  </div>
</template>

<script>
import { platformGuideDirectory, downloadFiles } from "@/model/guideFile";
import s3Api from "@/api/s3Api";

export default {
  data() {
    return {
      fileInfos: [],
    };
  },
  methods: {
    downloadGuide(fullUrl) {
      const origin = window.location.origin;
      window.open(`${origin}/${fullUrl}`);
    },
    loadDownloadUrl() {
      s3Api.getList(platformGuideDirectory).then((response) => {
        const data = response?.data;

        if (!data) {
          console.error("cannot find files");
          return;
        }

        let target = JSON.parse(JSON.stringify(downloadFiles));

        Object.values(data).forEach((e) => {
          const info = e.key.split(platformGuideDirectory)[1].split("/");

          for (let i = 0; i < target.length; i++) {
            if (info[0] === target[i].directory && info[1].startsWith(target[i].fileName)) {
              const encodedUrl = encodeURIComponent(info[1]);
              const fullUrl = `s3/${platformGuideDirectory}/${info[0]}/${encodedUrl}`;
              this.fileInfos.push(Object.assign({}, target[i], { fullUrl: fullUrl }));
              target = target.splice(i + 1);
              break;
            }
          }
        });
      });
    },
    showDownloadButton(pages) {
      const name = this.$route.name;
      return pages.includes(name);
    },
  },
  mounted() {
    this.loadDownloadUrl();
  },
};
</script>

<style scoped>
.btn-download {
  font-weight: 300 !important;
  font-size: 15px;
  position: relative;
}
</style>
